import { helper } from '@ember/component/helper';
import { bytesToReadable } from 'uplisting-frontend/utils/file-sizes';

export default helper(function ([bytes]: [number]): string {
  return bytesToReadable(bytes);
});
